import gql from 'graphql-tag'

export default gql`
    mutation SaveOrderProgress(
        $email: String!
        $data: String!
        $key: String!
        $salutation: String!
        $vzfID: String!
        $orderProcessType: String!
    ) {
        saveOrderProgress(
            email: $email
            data: $data
            key: $key
            salutation: $salutation
            vzfID: $vzfID
            orderProcessType: $orderProcessType
        ) {
            status
        }
    }
`
